/* eslint-disable no-underscore-dangle */
import { useMutation } from '@apollo/client';
import moment from 'moment';
import React, { useState } from 'react';
import {
  Jumbotron,
  Container,
  Row,
  Col,
  Input,
  Button,
  Alert,
  Spinner,
  Label,
} from 'reactstrap';
import { GENERATE_PHOTOBOOKS, GENERATE_PHOTOBOOK_FOR_USER, SEND_PHOTOBOOKS } from '../../mutation/mutation';

const PhotoBookManagerPage = () => {
  const startDateDefault = moment(new Date()).subtract(1, 'M').format('YYYY-MM-DD').toString();
  const endDateDefault = moment(new Date()).format('YYYY-MM-DD').toString();
  const [startDate, setStartDate] = useState(startDateDefault);
  const [endDate, setEndDate] = useState(endDateDefault);
  const [gelatoOrdersDate, setGelatoOrdersDate] = useState(endDateDefault);
  const [alertError, setAlertError] = useState(false);
  const [alertErrorUser, setAlertErrorUser] = useState(false);
  const [savGeneratePhotoBooksMutation] = useMutation(GENERATE_PHOTOBOOKS);
  const [savCreatePhotoBooksForUserMutation] = useMutation(GENERATE_PHOTOBOOK_FOR_USER);
  const [savSendPhotoBooksMutation] = useMutation(SEND_PHOTOBOOKS);
  const [data, setData] = useState();
  const [dataUser, setDataUser] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);
  const [limit, setLimit] = useState(3);
  const [offset, setOffset] = useState(0);
  const [customerEmail, setCustomerEmail] = useState();
  const [successPhotoBook, setSuccessPhotoBook] = useState(false);

  const generatePhotoBooks = async (limitValue, offsetValue) => {
    setSuccessPhotoBook(false);
    if (startDate !== startDateDefault && endDate !== endDateDefault && !customerEmail) {
      try {
        setLoading(true);
        const { data: { savGeneratePhotoBooks } } = await savGeneratePhotoBooksMutation({
          variables: {
            startDate,
            endDate,
            gelatoOrdersDate,
            limit: limitValue,
            offset: offsetValue,
          },
        });
        if (savGeneratePhotoBooks) {
          try {
            setData(JSON.parse(savGeneratePhotoBooks));
          } catch (e) {
            setData(savGeneratePhotoBooks);
          }
        }
        setLoading(false);
      } catch (e) {
        setAlertError(true);
      }
    }
  };

  const generatePhotoBookForUser = async () => {
    setAlertErrorUser(false);
    if (startDate !== startDateDefault && endDate !== endDateDefault && customerEmail) {
      try {
        setLoadingUser(true);
        const { data: { savCreatePhotoBookForUser } } = await savCreatePhotoBooksForUserMutation({
          variables: {
            startDate,
            endDate,
            email: customerEmail,
          },
        });
        if (savCreatePhotoBookForUser) {
          try {
            setDataUser(JSON.parse(savCreatePhotoBookForUser));
          } catch (e) {
            setDataUser(savCreatePhotoBookForUser);
          }
        }
        setLoadingUser(false);
      } catch (e) {
        setAlertErrorUser(true);
        setLoadingUser(false);
      }
    }
  };

  const onPressNext = async () => {
    const newOffset = offset + limit;
    await generatePhotoBooks(limit, newOffset);
    setOffset(newOffset);
  };

  const onSendPhotoBooks = async () => {
    if (data) {
      const orders = data;
      try {
        setLoading(true);
        const { data: { savSendPhotoBooks } } = await savSendPhotoBooksMutation({
          variables: {
            orders,
          },
        });
        if (savSendPhotoBooks) {
          setSuccessPhotoBook(true);
          setLoading(false);
        } else {
          setLoading(false);
          setAlertError(true);
        }
      } catch (e) {
        setAlertError(true);
        setLoading(false);
      }
    }
  };

  return (
    <Container>
      <Jumbotron className="templates">
        <h3>Photo Book Manager</h3>
        <hr className="my-2" />
        <Container>
          <Row>
            <Col>
              <div>
                <Row
                  style={{ marginBottom: 20 }}
                >
                  <Col>
                    <Label><b>Start date:</b></Label>
                    <Input
                      type="date"
                      placeholder="Choose a start date"
                      value={startDate}
                      onChange={({ target: { value } }) => setStartDate(value)}
                    />
                  </Col>
                  <Col>
                    <Label><b>End date:</b></Label>
                    <Input
                      type="date"
                      placeholder="Choose an end date"
                      value={endDate}
                      onChange={({ target: { value } }) => setEndDate(value)}
                    />
                  </Col>
                </Row>
                <div style={{ marginBottom: 20 }}>
                  <b>Generate photo books between dates: </b>
                </div>
                <Container>
                  <Row>
                    <Col>
                      <Label><b>Limit:</b></Label>
                      <Input
                        type="number"
                        placeholder="(recommended 3)"
                        value={limit}
                        onChange={({ target: { value } }) => setLimit(parseInt(value, 10))}
                      />
                    </Col>
                    <Col>
                      <Label><b>Limit date to fetch orders:</b></Label>
                      <Input
                        type="date"
                        placeholder="Choose a date"
                        value={gelatoOrdersDate}
                        onChange={({ target: { value } }) => setGelatoOrdersDate(value)}
                      />
                    </Col>
                    <Col>
                      <Button
                        type="submit"
                        color="primary"
                        onClick={async () => { await generatePhotoBooks(limit, offset); }}
                        style={{ marginTop: 30, marginBottom: 30 }}
                      >
                        Create photo books
                      </Button>
                    </Col>
                    {loading && <Spinner color="primary" />}
                    {data && !loading && (
                      <Col>
                        <div style={{ marginTop: 25 }}>
                          <b>Number of photo books created: </b>
                          {data.length}
                        </div>
                      </Col>
                    )}
                    {data && !loading && (data.map((d) => (
                      <Row style={{ marginBottom: 10 }}>
                        <Col>
                          <div>
                            <div>
                              <b>Customer email:</b>
                              {d.orderEmail}
                            </div>
                            <div>
                              <b>Photo book url:</b>
                              {d.pdf.url}
                            </div>
                            <div>
                              <b>Number of pages:</b>
                              {d.pdf.numberOfPages}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                    )}
                    {data && !loading && (
                      <Container>
                        <Row>
                          <Col>
                            <div
                              style={{ marginTop: 15 }}
                            >
                              <b>Offset: </b>
                              {limit}
                            </div>
                          </Col>
                          <Col>
                            <Button
                              type="submit"
                              color="primary"
                              onClick={async () => { await onPressNext(); }}
                              style={{ marginTop: 15 }}
                            >
                              Create more photo books
                            </Button>
                          </Col>
                          <Col>
                            <Button
                              type="submit"
                              color="success"
                              onClick={async () => { await onSendPhotoBooks(); }}
                              style={{ marginTop: 15 }}
                            >
                              Send photo books
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                    )}
                  </Row>
                  { alertError && <Alert color="danger"> Error generating photo books</Alert> }
                  { successPhotoBook && <Alert color="success"> Success sending photo books</Alert>}
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col>
              <div>
                <div style={{ marginBottom: 20 }}>
                  <b>Generate photo book for user by dates: </b>
                </div>
                <Container>
                  <Row>
                    <Col>
                      <Label><b>Generate by customer email:</b></Label>
                      <Input
                        type="text"
                        placeholder="Customer email address"
                        value={customerEmail}
                        onChange={({ target: { value } }) => setCustomerEmail(value)}
                      />
                    </Col>
                    <Col>
                      <Button
                        type="submit"
                        color="primary"
                        onClick={async () => { await generatePhotoBookForUser(); }}
                        style={{ marginTop: 30, marginBottom: 30 }}
                      >
                        Create photo book
                      </Button>
                    </Col>
                    {loadingUser && <Spinner color="primary" />}
                    {dataUser && !loadingUser && (
                      <Row style={{ marginBottom: 10 }}>
                        <Col>
                          <div>
                            <div>
                              <b>Customer email:</b>
                              {dataUser.orderEmail}
                            </div>
                            <div>
                              <b>Photo book url:</b>
                              {dataUser.pdf.url}
                            </div>
                            <div>
                              <b>Number of pages:</b>
                              {dataUser.pdf.numberOfPages}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Row>
                  { alertErrorUser && <Alert color="danger"> Error generating photo book</Alert> }
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
      </Jumbotron>
    </Container>
  );
};

export default PhotoBookManagerPage;



// WEBPACK FOOTER //
// ./src/components/photobook/photobook-manager.js